import { render, staticRenderFns } from "./NotifOwnerResponse.vue?vue&type=template&id=8c6573a8&scoped=true"
import script from "./NotifOwnerResponse.vue?vue&type=script&lang=js"
export * from "./NotifOwnerResponse.vue?vue&type=script&lang=js"
import style0 from "./NotifStyle.scss?vue&type=style&index=0&id=8c6573a8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c6573a8",
  null
  
)

export default component.exports